<template>
  <div class="panel-body">
    <v-card>
      <v-card-title>Select answers below</v-card-title>
       <v-spacer></v-spacer>
      <v-card-subtitle>Answered with...</v-card-subtitle>
      <v-treeview
        v-model="inAnswersModel"
        dense
        selectable
        selected-color="green"
        item-disabled="locked"
        :items="this.inAnswersItems"
      ></v-treeview>
      <v-card-subtitle>Did not answer with...</v-card-subtitle>
      <v-treeview
        v-model="notInAnswersModel"
        dense
        selectable
        selected-color="red"
        item-disabled="locked"
        :items="this.notInAnswersItems"
      ></v-treeview>
      <v-card-actions>
        <v-btn
          fab
          color="green"
          bottom
          right
          absolute
          @click="submit"
          style="bottom: 10px"
        >
          <v-icon color="white">mdi-check</v-icon>
        </v-btn>
        <v-btn
          fab
          color="red"
          bottom
          right
          absolute
          @click="cancel"
          style="right: 90px; bottom: 10px"
        >
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-overlay v-if="loadingQuestionnaires" absolute>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
let rh = require('@/components/APIs/RequestHandler')

export default {
  // props: ['auth'],
  props: {
    inAnswers: {
      type: Array,
      required: true,
      default: () => []
    },
    notInAnswers: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    inAnswersModel: [],
    notInAnswersModel: [],
    inAnswersItems: [],
    notInAnswersItems: [],
    selectedAnswers: [],
    selectedNotInAnswers: [],
    userIds: [],
    locked: false,
    loadingQuestionnaires: false
  }),

  components: {
  },

  computed: {
  },

  watch: {
    inAnswersModel (selection) {
      this.inAnswersChange(selection)
    },
    notInAnswersModel (selection) {
      this.notInAnswersChange(selection)
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.loadingQuestionnaires = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires?active=true`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.convertQuestionnairesToTreeViewItems(getResponse.data)
      this.inAnswersModel = this.inAnswers
      this.notInAnswersModel = this.notInAnswers
      this.loadingQuestionnaires = false
    },
    cancel () {
      this.$emit('cancel')
    },
    submit () {
      this.$emit('submit', JSON.stringify(this.inAnswersItems), JSON.stringify(this.notInAnswersItems), JSON.stringify(this.selectedAnswers), JSON.stringify(this.selectedNotInAnswers))
    },
    inAnswersChange (selections) {
      this.selectedAnswers = []
      if (selections !== null) {
        selections.forEach((value, index, a) => {
          this.selectedAnswers.push(value)
        })
      }
      this.notInAnswersItems.forEach((v1, n1, a1) => {
        v1.children.forEach((v2, n2, a2) => {
          this.lockChild(v2, selections)
        })
        this.checkParentLock(v1)
      })
    },
    notInAnswersChange (selections) {
      this.selectedNotInAnswers = []
      if (selections !== null) {
        selections.forEach((value, index, a) => {
          this.selectedNotInAnswers.push(value)
        })
      }
      this.inAnswersItems.forEach((v1, n1, a1) => {
        v1.children.forEach((v2, n2, a2) => {
          this.lockChild(v2, selections)
        })
        this.checkParentLock(v1)
      })
    },
    lockChild (child, selections) {
      if (selections !== null && child !== null) {
        if (selections.includes(child.id)) {
          child.locked = true
        } else {
          child.locked = false
        }
      }
    },
    checkParentLock (parent) {
      var allLocked = true
      if (parent !== null) {
        parent.children.forEach((v, n, a) => {
          if (v.locked === false) {
            allLocked = false
          }
        })
      }
      parent.locked = allLocked
    },
    convertQuestionnairesToTreeViewItems (questionnaires) {
      this.notInAnswersItems = this.convertToTreeView(questionnaires)
      this.inAnswersItems = this.convertToTreeView(questionnaires)
    },
    convertToTreeView (questionnaires) {
      var convertedQuestionnaires = []
      if (questionnaires !== null) {
        questionnaires.forEach((questionnaire, index, a) => {
          if (questionnaire.questionnaireQuestions !== null && questionnaire.questionnaireQuestions !== undefined) {
            if (questionnaire.typeCode === 'SURVEY' || questionnaire.typeCode === 'ADVISOR') {
              questionnaire.questionnaireQuestions.forEach((question, index, a) => {
                var answers = []
                if (question.answers !== null && question.answers !== undefined) {
                  question.answers.forEach((answer, index, a2) => {
                    var newAnswer = {
                      id: answer.id,
                      name: answer.title,
                      locked: false
                    }
                    answers.push(newAnswer)
                  })
                }
                if (answers !== null && answers.length !== 0) {
                  var newQuestion = {
                    id: 'question' + question.id,
                    name: question.question,
                    locked: false,
                    children: answers
                  }

                  convertedQuestionnaires.push(newQuestion)
                }
              })
              // } else if (questionnaire.typeCode === 'ADVISOR') {
              //   var answers = []
              //   var newAnswer = {
              //     id: 9999999,
              //     name: 'Yes',
              //     locked: false
              //   }
              //   answers.push(newAnswer)
              //   var newQuestion = {
              //     id: 'question' + questionnaire.questionnaireQuestions[0].question.id,
              //     name: questionnaire.name,
              //     type: questionnaire.typeCode,
              //     locked: false,
              //     children: answers
              //   }

            //   convertedQuestionnaires.push(newQuestion)
            }
          }
        })
        return convertedQuestionnaires
      } else {
        return null
      }
    }

  }
}
</script>
<style>
  .fab-container {
    position: fixed;
    bottom: 0;
    right: 0;
  }
</style>
